import './Letterbox.css';

import * as LetterRepo from '../Letterbox/LetterRepository'
import { useState, useRef } from 'react';
import React from 'react'
import { useReactToPrint } from "react-to-print";

function LetterboxForm() {
    const [theWords, setWords] = useState([]);
    const [, setLetters] = useState([]);
    const [theBoxes, setBoxes] = useState([]);
    const contentRef = useRef();

    const [zoomFactor, setZoomFactor] = useState(1);

    const reactToPrintFn = useReactToPrint({ contentRef });

    const wordsToProcessRef = useRef();

    const updateOnInput = () => {
        var data = wordsToProcessRef.current.value;
        ProcessWords(setWords, setLetters, setBoxes, data, zoomFactor);
    }

    const handleZoomChange = (event) => {
        const newZoomFactor = parseFloat(event.target.value);
        setZoomFactor(newZoomFactor);
        var data = wordsToProcessRef.current.value;
        if (data) {
            ProcessWords(setWords, setLetters, setBoxes, data, newZoomFactor);
        }
    }

    return (
        <div>
            <div className="st-noprint st-form-card">
                <div className="st-form-left">
                    <div className="st-field">
                        <label className="st-label">Ord separert med komma:</label>
                        <textarea
                            ref={wordsToProcessRef}
                            onChange={updateOnInput}
                            rows={2}
                            placeholder="sol, måne, stjerne"
                            className="st-textarea"
                        />
                    </div>
                    <div className="st-zoom-field">
                        <label className="st-label">Zoom faktor</label>
                        <select
                            value={zoomFactor}
                            onChange={handleZoomChange}
                            className="st-select"
                        >
                            <option value={0.75}>0.75</option>
                            <option value={1}>1</option>
                            <option value={1.25}>1.25</option>
                            <option value={1.5}>1.5</option>
                        </select>
                    </div>
                </div>

                <div className="st-form-right">
                    <span className="st-label">&nbsp;</span>
                    <button onClick={() => reactToPrintFn()} className="st-print-btn">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 9V2h12v7"/>
                            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                            <rect x="6" y="14" width="12" height="8"/>
                        </svg>
                        Skriv ut
                    </button>
                </div>
            </div>

            <div className="st-paper-wrap">
                <div className="st-paper-mat">
                    <div id="renderedWords" className="st-paper" ref={contentRef}>
                        {theWords.length > 0 ? (
                            <>
                                <div className="st-name-row">
                                    <div className="st-name-label">Navn:</div>
                                    <div className="st-name-line">&nbsp;</div>
                                </div>
                                <div className="st-word-list">
                                    {theWords.map((word, i) => (
                                        <span key={i} style={{marginRight:'26px', whiteSpace:'nowrap'}}>{word.word}</span>
                                    ))}
                                </div>
                                <div style={{height:'66px'}} />
                                <div style={{textAlign:'center'}}>
                                    {theBoxes.map((box, boxIndex) => (
                                        GetBoxDiv(box, boxIndex, zoomFactor)
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="st-empty-state">
                                <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="16" rx="1"/>
                                    <path d="M3 9h18M8 9v11"/>
                                </svg>
                                <div>Skriv inn ord ovenfor for å lage ordbokser.</div>
                            </div>
                        )}
                        <div className="page-footer"></div>
                    </div>
                </div>
            </div>
            <p className="st-noprint st-preview-note">Forhåndsvisningen viser ikke sideskift — utskriften blir korrekt.</p>
        </div>
    );
}

function GetBoxDiv(boxElement, boxIndex, zoomFactor = 1) {
    return (
        <div style={{display:'flex', marginBottom:'15px'}} key={"wordBox_" + boxIndex}>
            {boxElement.map((word, wordIndex) => (
                GetWordDiv(word, wordIndex, boxIndex, zoomFactor)
            ))}
        </div>
    );
}

function GetWordDiv(wordElement, wordIndex, boxIndex, zoomFactor = 1) {
    return (
        <div style={{flex:'auto', marginBottom:'15px'}} key={"wordBox_" + boxIndex + "_word_" + wordIndex}>
            {wordElement.letters.map((letterElement, letterElementIndex) => (
                GetSpan(letterElement, wordIndex, letterElementIndex, zoomFactor)
            ))}
        </div>
    );
}

function GetSpan(letterElement, wordIndex, letterElementIndex, zoomFactor = 1) {
    var letterHeight = letterElement.calculatedLetterHeight * zoomFactor;
    var marginBottom = letterElement.calculatedMarginBottom * zoomFactor;
    var adjustmentForCellarAndAttic = letterElement.calculatedAdjustmentForCellarAttic * zoomFactor;
    var letterWidth = letterElement.width * zoomFactor;

    var marginTop = 0;
    if (letterElement.height === 1 || letterElement.toCellar)
        marginTop = letterHeight / letterElement.height;

    if (letterElement.startPosition === 1 && letterElement.height > 1)
        letterHeight -= adjustmentForCellarAndAttic;
    else if (letterElement.startPosition === 0 && letterElement.height > 1) {
        letterHeight -= adjustmentForCellarAndAttic;
        marginBottom += adjustmentForCellarAndAttic;
    }

    return (
        <span
            key={"spanKey_" + wordIndex + "_" + letterElementIndex}
            style={{
                height: letterHeight + 'px',
                width: letterWidth + 'px',
                border: '1px solid #141414',
                display: 'inline-block',
                verticalAlign: 'bottom',
                marginBottom: marginBottom + 'px',
                marginTop: marginTop + 'px',
                boxSizing: 'border-box'
            }}
        />
    );
}

function ProcessWords(setWords, setLetters, setBoxes, words, zoomFactor = 1) {
    if (words.length === 0) {
        setWords([]);
        setLetters([]);
        return;
    }

    var wordList = words.split(",").filter(word => word.trim() !== '');
    var outputWords = [];

    wordList.forEach(word => {
        var letters = Array.from(word);
        var outputLetters = [];

        letters.forEach(letter => {
            var foundLetter = LetterRepo.kvArray.find(kv => kv.key === letter);
            if (foundLetter) {
                outputLetters.push(foundLetter.value);
            }
        });

        var outputWord = new LetterRepo.Word(word, outputLetters);
        outputWords.push(outputWord);
    });

    var theWords = outputWords;
    var theLetters = outputWords.map(word => word.letters);

    var displayAreaWidth = document.getElementById("renderedWords")?.getBoundingClientRect()?.width;
    var boxes = ReorderWords(theWords, displayAreaWidth, zoomFactor);

    setBoxes(boxes);
    setWords(theWords);
    setLetters(theLetters);
}

function ReorderWords(words, displayAreaWidth, zoomFactor = 1) {
    return FitItemsIntoBoxes(words, displayAreaWidth, zoomFactor);
}

function FitItemsIntoBoxes(items, boxLength, zoomFactor = 1) {
    const space = 25 * zoomFactor;
    const maxPerBox = 3;

    items.sort((a, b) => a.totalWordLength - b.totalWordLength);

    const boxes = [];

    function fillBox(remainingItems, currentBox, currentLength) {
        let newItems = [];
        let itemsInBox = 0;

        for (let i = 0; i < remainingItems.length; i++) {
            const item = remainingItems[i];
            const itemLength = (item.totalWordLength * zoomFactor) + space;

            if (currentLength + itemLength <= boxLength && itemsInBox < maxPerBox) {
                currentBox.push(item);
                currentLength += itemLength;
                itemsInBox++;
            } else {
                newItems.push(item);
            }
        }

        currentBox.sort((a, b) => 0.5 - Math.random());
        boxes.push(currentBox);

        if (newItems.length > 0) {
            fillBox(newItems, [], 0);
        }
    }

    fillBox(items, [], 0);
    boxes.sort((a, b) => 0.5 - Math.random());
    return boxes;
}

export default LetterboxForm;
